// extracted by mini-css-extract-plugin
module.exports = {"body":"login_body__3eMoM","heading":"login_heading__2udDF","loginForm":"login_loginForm__37Cm6"};